(function () {
  document.addEventListener("turbo:load", function (event) {
    svg4everybody()
    $('[data-toggle="dropdown"]').dropdown()
    autoDismissFlashMessages()
  });

  function autoDismissFlashMessages() {
    const flashes = document.querySelectorAll('.flash_messages .flashes, .flash')
    if (!flashes.length) return
    setTimeout(() => {
      flashes.forEach((el) => {
        $(el).fadeOut(300, function () { $(this).remove() })
      })
    }, 4000)
  }

  document.addEventListener('turbo:before-fetch-request', (event) => {
    event.detail.fetchOptions.headers['Turbo-Referrer'] = window.location.href
    event.detail.fetchOptions.headers['X-Turbo-Nonce'] = Rails.default.cspNonce()
  })

  document.addEventListener("turbo:before-cache", function() {
    let scriptTagsToAddNonces = document.querySelectorAll("script[nonce]");
    for (var element of scriptTagsToAddNonces) {
      element.setAttribute('nonce', element.nonce);
    }

    // Manually tear down bootstrap modals before caching. If turbolinks
    // caches the modal then tries to restore it, it breaks bootstrap's JS.
    // We can't just use bootstrap's `modal('close')` method because it is async.
    // Turbolinks will cache the page before it finishes running.
    if (document.body.classList.contains('modal-open')) {
      $('.modal')
        .hide()
        .removeAttr('aria-modal')
        .attr('aria-hidden', 'true');
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
    }
  });
})()